import type { IntegrationProvider } from '@brew/integration-contracts'

/**
 * Public web domain for each integration, used for domain-keyed logo lookups
 * (context.dev Logo Link) and favicon fallbacks. A static map on purpose:
 * client logo code imports it, and reading provider definitions here would
 * ship every canonical definition to the browser. A definition that declares
 * `brandDomain` must match this map (tests/integration-brand-domains.test.ts).
 */
export const INTEGRATION_BRAND_DOMAIN: Readonly<
  Record<IntegrationProvider, string>
> = {
  figma: 'figma.com',
  framer: 'framer.com',
  slack: 'slack.com',
  hubspot: 'hubspot.com',
  braze: 'braze.com',
  brevo: 'brevo.com',
  clerk: 'clerk.com',
  customerio: 'customer.io',
  klaviyo: 'klaviyo.com',
  mailchimp: 'mailchimp.com',
  loops: 'loops.so',
  mailjet: 'mailjet.com',
  stripe: 'stripe.com',
  typeform: 'typeform.com',
  iterable: 'iterable.com',
  postmark: 'postmarkapp.com',
  onesignal: 'onesignal.com',
  mailgun: 'mailgun.com',
  sendgrid: 'sendgrid.com',
  stytch: 'stytch.com',
  supabase: 'supabase.com',
  workos: 'workos.com',
  shopify: 'shopify.com',
  revenuecat: 'revenuecat.com',
  notion: 'notion.so',
}

export function getIntegrationBrandDomain(
  provider: IntegrationProvider
): string {
  return INTEGRATION_BRAND_DOMAIN[provider]
}

export function normalizeBrandDomain(domain: string): string {
  return domain
    .replace(/^https?:\/\//i, '')
    .split('/')[0]
    .replace(/^www\./i, '')
}

export function integrationGoogleFaviconUrl(
  domain: string,
  pixelSize: 128 | 256 = 256
): string {
  const clean = normalizeBrandDomain(domain)
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(clean)}&sz=${pixelSize}`
}
